export enum DecorType {
  Decor = 0,
  Panel = 1,
  DecorativeBoard = 2
}
